module.exports = __webpack_public_path__ + "static/bidDrawing-24b241973ec896ff77cc5297a7e5162b.png";